export default __webpack_public_path__ + "assets/cozumel.5b5515e4.jpg";